/* Areish Wellness interactions */
document.addEventListener('DOMContentLoaded', function () {
  // Reveal on scroll
  var io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  document.querySelectorAll('.rv').forEach(function (el) {
    io.observe(el);
  });

  // Nav shadow
  var nav = document.getElementById('nav');
  if (nav) {
    addEventListener(
      'scroll',
      function () {
        nav.classList.toggle('sc', scrollY > 12);
      },
      { passive: true }
    );
  }

  // Mobile burger — toggle links
  var burger = document.querySelector('[data-areish-burger]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.fq2').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.parentElement;
      var pa = it.parentElement;
      var open = it.classList.contains('op');
      pa.querySelectorAll('.fi').forEach(function (o) {
        o.classList.remove('op');
        var a = o.querySelector('.fa');
        if (a) a.style.maxHeight = null;
      });
      if (!open) {
        it.classList.add('op');
        var a = it.querySelector('.fa');
        if (a) a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  // Buy options — swap variant + price
  document.querySelectorAll('[data-areish-buy]').forEach(function (buy) {
    buy.querySelectorAll('.o').forEach(function (o) {
      o.addEventListener('click', function () {
        buy.querySelectorAll('.o').forEach(function (x) {
          x.classList.remove('on');
        });
        o.classList.add('on');
        var pv = buy.querySelector('#pv') || document.getElementById('pv');
        if (pv && o.dataset.p) pv.textContent = o.dataset.p;
        var input = buy.querySelector('#areish-variant-id') || document.getElementById('areish-variant-id');
        if (input && o.dataset.variantId) input.value = o.dataset.variantId;
        var pdpPrice = document.getElementById('areish-pdp-price');
        if (pdpPrice && o.dataset.p) pdpPrice.textContent = o.dataset.p;
        var compare = document.getElementById('areish-pdp-compare');
        if (compare) {
          if (o.dataset.compare) {
            compare.textContent = o.dataset.compare;
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      });
    });
  });

  // PDP gallery — clickable thumbnails swap main image
  document.querySelectorAll('[data-areish-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('#areish-gallery-main');
    if (!main) return;
    gallery.querySelectorAll('.areish-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!src) return;
        main.style.opacity = '0.35';
        var next = new Image();
        next.onload = function () {
          main.src = src;
          main.alt = alt;
          main.style.opacity = '1';
        };
        next.src = src;
        gallery.querySelectorAll('.areish-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  // —— Cart drawer helpers ——
  function areishCartDrawer() {
    return document.querySelector('theme-drawer#cart-drawer');
  }

  function areishUpdateBagCount(count) {
    var el = document.querySelector('[data-areish-cart-count]');
    if (el) el.textContent = '(' + count + ')';
    var bag = document.getElementById('areish-cart-link');
    if (bag) bag.setAttribute('aria-expanded', count > 0 ? bag.getAttribute('aria-expanded') : 'false');
  }

  function areishOpenCartDrawer() {
    var drawer = areishCartDrawer();
    if (!drawer) {
      window.location.href = '/cart';
      return false;
    }
    if (typeof drawer.open === 'function') {
      drawer.open();
      var bag = document.getElementById('areish-cart-link');
      if (bag) bag.setAttribute('aria-expanded', 'true');
      return true;
    }
    if (window.Shopify && Shopify.actions && Shopify.actions.openCart) {
      Shopify.actions.openCart();
      return true;
    }
    return false;
  }

  function areishReplaceCartDrawerSection(html) {
    if (!html) return;
    var current = document.getElementById('shopify-section-cart-drawer-section');
    if (!current) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html.trim();
    var next = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
    if (!next) return;
    current.replaceWith(next);
  }

  function areishRefreshCartDrawer() {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + '?sections=cart-drawer-section';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        areishReplaceCartDrawerSection(data['cart-drawer-section']);
      })
      .catch(function () {});
  }

  // Ajax add to cart — refresh drawer markup, bag count, then open
  document.querySelectorAll('form.areish-add-form, [data-areish-buy-form] form, form[action*="/cart/add"]').forEach(function (form) {
    if (form.dataset.areishBound) return;
    if (!form.querySelector('#areish-variant-id, input[name="id"]')) return;
    form.dataset.areishBound = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer-section');
      fd.append('sections_url', window.location.pathname);
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (payload) {
          if (payload.sections && payload.sections['cart-drawer-section']) {
            areishReplaceCartDrawerSection(payload.sections['cart-drawer-section']);
          }
          return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js').then(
            function (r) {
              return r.json();
            }
          );
        })
        .then(function (cart) {
          areishUpdateBagCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          if (!areishOpenCartDrawer()) {
            return areishRefreshCartDrawer().then(function () {
              areishOpenCartDrawer();
            });
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  });

  // Bag link opens drawer (falls back to /cart)
  document.querySelectorAll('[data-areish-cart-open], #areish-cart-link').forEach(function (bag) {
    if (bag.dataset.areishCartBound) return;
    bag.dataset.areishCartBound = '1';
    bag.addEventListener('click', function (e) {
      if (!areishCartDrawer()) return;
      e.preventDefault();
      var drawer = areishCartDrawer();
      if (drawer && drawer.hasAttribute('open')) {
        if (typeof drawer.close === 'function') drawer.close();
        bag.setAttribute('aria-expanded', 'false');
      } else {
        areishOpenCartDrawer();
      }
    });
  });
});
